import { render, staticRenderFns } from "./qaassess.vue?vue&type=template&id=6ed81c3d&"
import script from "./qaassess.vue?vue&type=script&lang=js&"
export * from "./qaassess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports